import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { FolderTree, HardDrive, LogOut, ScrollText, Trash2, Users, UsersRound } from 'lucide-react';
import { useSesion } from '../lib/sesion.js';
import { ETIQUETA_ROL, iniciales } from '../lib/formato.js';

export function Marco({ children }: { children: ReactNode }) {
  const { usuario, salir, esAdmin } = useSesion();
  const esSuperAdmin = usuario?.rol === 'SUPER_ADMIN';
  if (!usuario) return null;

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar__brand">
          <div className="logo">
            <FolderTree size={16} />
          </div>
          <div>
            <div className="name">Documental</div>
            <div className="sub">{usuario.organizacionNombre}</div>
          </div>
        </div>

        <nav className="sidebar__nav">
          <NavLink to="/archivos" className={({ isActive }) => `navlink${isActive ? ' active' : ''}`}>
            <FolderTree size={15} /> Archivos
          </NavLink>
          <NavLink to="/papelera" className={({ isActive }) => `navlink${isActive ? ' active' : ''}`}>
            <Trash2 size={15} /> Papelera
          </NavLink>

          {esAdmin && (
            <>
              <div className="nav-group__label">Administración</div>
              <NavLink to="/usuarios" className={({ isActive }) => `navlink${isActive ? ' active' : ''}`}>
                <Users size={15} /> Usuarios
              </NavLink>
              <NavLink to="/grupos" className={({ isActive }) => `navlink${isActive ? ' active' : ''}`}>
                <UsersRound size={15} /> Grupos
              </NavLink>
              <NavLink to="/bitacora" className={({ isActive }) => `navlink${isActive ? ' active' : ''}`}>
                <ScrollText size={15} /> Bitácora
              </NavLink>
              {esSuperAdmin && (
                <NavLink to="/cuotas" className={({ isActive }) => `navlink${isActive ? ' active' : ''}`}>
                  <HardDrive size={15} /> Cuotas
                </NavLink>
              )}
            </>
          )}
        </nav>

        <div className="sidebar__user">
          <div className="userchip">
            <div className="avatar">{iniciales(usuario.nombre)}</div>
            <div style={{ minWidth: 0 }}>
              <div className="uname nowrap">{usuario.nombre}</div>
              <div className="urol">{ETIQUETA_ROL[usuario.rol]}</div>
            </div>
          </div>
          <button className="btn btn--fantasma" style={{ width: '100%' }} onClick={() => void salir()}>
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="main">{children}</main>
    </div>
  );
}

/** Cabecera de las páginas que no son el explorador. */
export function Cabecera({ titulo, subtitulo, acciones }: { titulo: string; subtitulo?: string; acciones?: ReactNode }) {
  return (
    <div className="topbar">
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: 'var(--ff-head)', fontSize: '1.35rem', fontWeight: 800, lineHeight: 1.1 }}>
          {titulo}
        </div>
        {subtitulo && <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>{subtitulo}</div>}
      </div>
      {acciones}
    </div>
  );
}
